import { FC } from 'react';

import { CheckableChip, Text } from '@hh.ru/magritte-ui';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';
import getDataQa from 'src/utils/getDataQa';

import styles from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorSkills/styles.less';

const DATA_QA_BLOCK = 'calculator-skills';

const CalculatorSkills: FC = () => {
    const { skillsGroup, selectedSkills, handleToggleSkill } = useCalculatorContext();

    return (
        <ul className={styles.container} data-qa={getDataQa(DATA_QA_BLOCK)}>
            {skillsGroup.map((group) => (
                <li key={group.id} data-qa={getDataQa(DATA_QA_BLOCK, 'group', group.id)}>
                    <div className={styles.groupTitle}>
                        <Text typography="paragraph-2-regular" style="secondary" Element="p">
                            {group.name}
                        </Text>
                    </div>
                    <ul className={styles.groupList}>
                        {group.skills.map((skill) => (
                            <li key={skill.id}>
                                <CheckableChip
                                    type="checkbox"
                                    value={skill.id}
                                    onChange={() => handleToggleSkill(skill)}
                                    checked={selectedSkills.map.has(skill.id)}
                                    data-qa={getDataQa(DATA_QA_BLOCK, 'skill', skill.id)}
                                >
                                    {skill.name}
                                </CheckableChip>
                            </li>
                        ))}
                    </ul>
                </li>
            ))}
        </ul>
    );
};

export default CalculatorSkills;
